import {promisifyModal} from 'common/components/modal/utils';

import {InlineCohortsModalAttrsJsxProps, InlineCohortsModalCommitEvent} from './types';

export async function promptInlineCohorts(
  attrs: InlineCohortsModalAttrsJsxProps['attrs'],
): Promise<{
  cohortStagedValue: InlineCohortsModalCommitEvent['detail'];
  cohortSavedValue: InlineCohortsModalCommitEvent['detail'];
}> {
  const closeEv = await promisifyModal<InlineCohortsModalCommitEvent>({
    tagName: `mp-inline-cohorts-modal`,
    attrs,
    closeEvents: [`close`, `commitCohort`, `commitSavedCohort`],
  });

  return {
    cohortStagedValue: closeEv.type === `commitCohort` ? closeEv.detail : null,
    cohortSavedValue: closeEv.type === `commitSavedCohort` ? closeEv.detail : null,
  };
}
